
import { Component, Vue } from 'vue-property-decorator'

import authModule from '@/store/auth'
import companyModule from '@/store/company'

import PartnerEditor from '@/components/company/partner/PartnerEditor.vue'
import ContentList from '@/components/listView/ContentList.vue'
import { ListType } from '@/utils/enums'
import whitelabel from '@/store/whitelabel'

@Component({
  name: 'PartnerList',
  components: {
    PartnerEditor,
    ContentList
  }
})
class PartnerList extends Vue {
  public listType = ListType

  public get storeModule() {
    return companyModule
  }

  public get partners() {
    return companyModule.partners.map(el => el.user)
  }

  public get headers() {
    return [
      { text: 'Email', value: 'email' },
      { text: 'Vorname', value: 'firstName' },
      { text: 'Nachname', value: 'lastName' },
      { text: 'Status', value: 'statusInvitation' },
      ...(whitelabel.whitelabel.flags.lightPartners
        ? [{ text: 'Typ', value: 'role' }]
        : []),
      { text: 'Entfernen', value: 'actionDelete', sortable: false }
    ]
  }

  public deletePartner(partner: any) {
    companyModule.unlinkPartner({
      whitelabel: authModule.user!.whitelabel._id!,
      userId: partner._id
    })
  }
}

export default PartnerList
